module.exports = __webpack_public_path__ + "img/album21_06.db59f562.jpg";